__turbopack_context__.v({
  "accent": "zCk2lq_accent",
  "mine": "zCk2lq_mine",
  "party": "zCk2lq_party",
  "tile": "zCk2lq_tile",
});
